import React, { PureComponent } from 'react';
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";

import wifiConfig from '../config/wifi.json';
import CardMedia from '@material-ui/core/CardMedia';
import Card from '@material-ui/core/Card';
import MaybeLink from '../util/MaybeLink';


const useStyles = makeStyles((theme) => ({
    cardMediaStyle: {
        height: 'auto',
        backgroundColor: '#d0d0d0',
        cursor: 'pointer',
        display: 'block',
    },
    card: {
        borderRadius: 8,
        overflow: 'hidden',
        margin: '8px 0',
    },
}));

class WifiButton extends PureComponent {
    render() {
        const { classes } = this.props;
        
        return(
            <MaybeLink
                externalLink={wifiConfig.loginPageUrl}
                target="_self"
            >
                <Card className={classes.card} elevation={11}>
                    <CardMedia
                        className={classes.cardMediaStyle}
                        image="/images/uestra_wlan_button.png"
                        component='img'
                        alt="Jetzt verbinden mit dem Gratis ÜSTRA-WLAN"
                    />
                </Card>
            </MaybeLink>
        );
    }
}

WifiButton.propTypes = {
    data: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
};

export default function _WifiButton(props) {
    const classes = useStyles();
    return <WifiButton {...props} classes={classes} />;
}
